import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { track } from '@/utils/tracker';

interface VipUpgradeSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function VipUpgradeSheet({ isOpen, onClose }: VipUpgradeSheetProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  useEffect(() => {
    if (isOpen) track.vipSheetView('generate_vip_unlock');
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose}></div>
      <div className="relative w-full max-w-md bg-white rounded-t-3xl px-6 pt-6 animate-slide-up" style={{ paddingBottom: 'calc(2.5rem + env(safe-area-inset-bottom))' }}>
        <div className="w-12 h-1 rounded-full bg-gray-200 mx-auto mb-5" />
        <div className="flex flex-col items-center mb-5">
          <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-3" style={{ background: 'linear-gradient(135deg, #FFF3CD, #FEF3C7)' }}>
            <i className="ri-vip-crown-2-line text-3xl" style={{ color: '#F59E0B' }}></i>
          </div>
          <h3 className="text-xl font-bold text-gray-800 mt-1">{t('vip_unlock_ultra_title')}</h3>
          <p className="text-sm text-gray-400 mt-1">{t('vip_unlock_ultra_desc')}</p>
        </div>
        <div className="space-y-3 mb-6">
          {[t('vip_unlock_benefit1'), t('vip_unlock_benefit2')].map((item, i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: 'linear-gradient(135deg, #FF6B9D, #A855F7)' }}>
                <i className="ri-check-line text-white text-xs"></i>
              </div>
              <span className="text-sm text-gray-700">{item}</span>
            </div>
          ))}
        </div>
        <button
          onClick={() => { onClose(); navigate('/membership'); }}
          className="w-full h-14 rounded-2xl text-white font-bold text-base cursor-pointer whitespace-nowrap active:scale-95 transition-transform"
          style={{ background: 'linear-gradient(135deg, #FF6B9D, #A855F7)' }}
        >
          {t('vip_open_now')}
        </button>
        <button onClick={onClose} className="w-full h-10 mt-3 bg-transparent text-gray-400 text-sm font-medium cursor-pointer whitespace-nowrap">
          {t('vip_not_now')}
        </button>
      </div>
    </div>
  );
}
